import { cx } from 'classix'
import React from 'react'

import ArrowSvg from './ArrowSvg'

const buttonVariants = {
  primary: { buttonClass: 'btn-primary hover:text-white', arrowColor: 'white' },
  secondary: { buttonClass: 'btn-secondary', arrowColor: 'white' },
  'outline-primary': { buttonClass: 'btn-outline-primary hover:text-black', arrowColor: 'black' },
}

type Props = {
  text: string
  to: string
  variant?: keyof typeof buttonVariants
  targetBlank?: boolean
} & React.HTMLAttributes<HTMLAnchorElement>

export default function ArrowedButtonLink({
  text,
  className,
  to,
  variant = 'primary',
  targetBlank = false,
  ...rest
}: Props) {
  const buttonVariant = buttonVariants[variant]
  return (
    <a
      target={targetBlank ? '_blank' : undefined}
      href={to}
      {...rest}
      className={cx(buttonVariant.buttonClass, className)}
    >
      <div className='flex items-center h-full'>
        <ArrowSvg className={'mr-2 h-5 w-5'} color={buttonVariant.arrowColor} />
        <span className='text-sm sm:text-base'>{text}</span>
      </div>
    </a>
  )
}
